// Everything that differs between the mobil and the trado editor, in one place.
// The editor hooks / components in features/cek-keluar-masuk/{hooks,components} read these values.
const tradoEditorConfig = {
  // url part that tells the "berangkat" page apart from the "kembali" page
  berangkatUrlPart: "cek-keluar-masuk-trado/berangkat",

  // vehicles the vehicle selector may show (trado: only trado)
  kendaraanSelectorFilter: "data_kendaraan_jenis.nama:=:Trado",

  // the vehicle can only be changed on the "berangkat" page
  lockVehicleOnKembali: true,

  // marking options are filtered by vehicle type (trado: only 16,17)
  kendaraanJenisFilter: "in:16,17",

  // whether the trailer (checklist + photos) is required for a side when verifying.
  // The cards are always shown, but a trailer is optional: only required when one is chosen for that side.
  hasTrailer: (headerData, side) =>
    side === "kembali"
      ? !!(headerData.trailer_pulang_id || headerData.data_trailer_pulang)
      : !!(headerData.trailer_berangkat_id || headerData.data_trailer_berangkat),

  // extra keys removed from the header before it is saved
  saveHeaderDeleteKeys: [
    "data_trailer_berangkat",
    "data_trailer_pulang",
    "data_trailer",
    "data_pengecekan_berangkat",
    "data_pengecekan_pulang",
  ],

  // part appended to the problem filter for the trailer(s)
  getTrailerProblemFilter: (headerData) => {
    let filter = "";
    if (
      headerData.trailer_berangkat_id &&
      headerData.trailer_berangkat_id > 0
    ) {
      filter += `||trailer_id:=:${headerData.trailer_berangkat_id}`;
    }
    if (headerData.trailer_pulang_id && headerData.trailer_pulang_id > 0) {
      filter += `||trailer_id:=:${headerData.trailer_pulang_id}`;
    }
    return filter;
  },

  // vehicle lines of the WhatsApp report ("No.pol" up to "Tujuan")
  buildWhatsappVehicleLines: (headerData) => {
    let lines = "";
    lines += `No.pol : ${headerData.data_kendaraan?.nomor_polisi}\n`;
    lines += `No.trailer Berangkat : ${
      headerData.data_trailer_berangkat?.nomor ?? "-"
    }\n`;
    lines += `No.trailer Pulang : ${
      headerData.data_trailer_pulang?.nomor ?? "-"
    }\n`;
    lines += `Supir Berangkat : ${headerData.data_supir?.nama} \n`;
    lines += `Supir Pulang : ${headerData.data_supir_pulang?.nama} \n`;
    lines += `Tujuan : ${headerData.data_tujuan?.nama} \n\n`;
    return lines;
  },
};

export default tradoEditorConfig;
